import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "./contexts/AuthContext";
import { OffersProvider } from "./contexts/OffersContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import PrivateRoute from "./components/PrivateRoute";
import TopProgressBar from "./components/TopProgressBar";
import Layout from "./components/Layout";
import { preloadCriticalPages } from "./utils/lazyImports";

// 同步加载关键页面
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
  components: {
    // 全局禁用所有按钮的 ripple 效果以提升性能
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiIconButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiListItemButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiFab: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiChip: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiCardActionArea: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiToggleButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});

function App() {
  // 预加载关键页面
  useEffect(() => {
    preloadCriticalPages();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LoadingProvider>
        <AuthProvider>
          <OffersProvider>
            <Router future={{ v7_startTransition: true }}>
              <TopProgressBar />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/*"
                  element={
                    <PrivateRoute>
                      <Layout />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Router>
          </OffersProvider>
        </AuthProvider>
      </LoadingProvider>
    </ThemeProvider>
  );
}

export default App;
